export const SEON_SESSION_ID_HEADER = "seon-session-id";

export enum SEON_FEATURE {
  ONBOARDING = "onboarding",
  LOGIN = "login",
  REGISTER = "register",
  DEPOSIT = "deposit",
  WITHDRAWAL = "withdrawal",
  PROMOTION = "promotion",
  PROMOTION_CASHBACK = "promotion_cashback",
  PROMOTION_MEGA_SHARE = "promotion_mega_share",
  PROMOTION_DAILY_LOGIN = "promotion_daily_login",
  PROMOTION_CASHBACK_DAILY = "promotion_cashback_daily",
  PROMOTION_CASHBACK_WEEKLY = "promotion_cashback_weekly",
  PROMOTION_CASHBACK_MONTHLY = "promotion_cashback_monthly",
  PROMOTION_CASHBACK_INSTANT = "promotion_cashback_instant",
  PROMOTION_REFER_FRIEND = "promotion_refer_friend",
  PROMOTION_REFER_BALLS = "promotion_refer_balls",
}
